import axios from 'axios';

// Get all suppliers
export const getSuppliers = async (filters = {}) => {
  try {
    let queryString = '';
    if (filters.search) queryString += `search=${encodeURIComponent(filters.search)}&`;

    const token = localStorage.getItem('token');
    const res = await axios.get(`/api/suppliers${queryString ? '?' + queryString : ''}`, {
      headers: {
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error fetching suppliers' };
  }
};

// Get supplier by ID
export const getSupplierById = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.get(`/api/suppliers/${id}`, {
      headers: {
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error fetching supplier details' };
  }
};

// Get parts from a supplier
export const getSupplierParts = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.get(`/api/suppliers/${id}/parts`, {
      headers: {
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error fetching supplier parts' };
  }
};

// Create new supplier
export const createSupplier = async (supplierData) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.post('/api/suppliers', supplierData, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error creating supplier' };
  }
};

// Update supplier
export const updateSupplier = async (id, supplierData) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.put(`/api/suppliers/${id}`, supplierData, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error updating supplier' };
  }
};

// Delete supplier
export const deleteSupplier = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.delete(`/api/suppliers/${id}`, {
      headers: {
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error deleting supplier' };
  }
};

// Add a part to a supplier
export const addPartToSupplier = async (supplierId, partId, partData) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.post(`/api/suppliers/${supplierId}/parts/${partId}`, partData, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error adding part to supplier' };
  }
};

// Update a supplier part
export const updateSupplierPart = async (supplierId, partId, partData) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.put(`/api/suppliers/${supplierId}/parts/${partId}`, partData, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error updating supplier part' };
  }
};

// Delete a supplier part
export const deleteSupplierPart = async (supplierId, partId) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.delete(`/api/suppliers/${supplierId}/parts/${partId}`, {
      headers: {
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error removing part from supplier' };
  }
};

// Remove a part from a supplier
export const removePartFromSupplier = async (supplierId, partId) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.delete(`/api/suppliers/${supplierId}/parts/${partId}`, {
      headers: {
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error removing part from supplier' };
  }
};

// Add a UPC code to a supplier part
export const addUpcToSupplierPart = async (supplierId, partId, upcData) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.post(`/api/suppliers/${supplierId}/parts/${partId}/upcs`, upcData, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error adding UPC code to supplier part' };
  }
};

// Update a UPC code
export const updateUpc = async (supplierId, partId, upcId, upcData) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.put(`/api/suppliers/${supplierId}/parts/${partId}/upcs/${upcId}`, upcData, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error updating UPC code' };
  }
};

// Delete a UPC code
export const deleteUpc = async (supplierId, partId, upcId) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.delete(`/api/suppliers/${supplierId}/parts/${partId}/upcs/${upcId}`, {
      headers: {
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error deleting UPC code' };
  }
};